"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetSelector = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _AssetCard = _interopRequireDefault(require("../AssetCard/AssetCard"));

var _Grid = _interopRequireDefault(require("@civicplus/preamble/lib/Grid"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _ButtonGroup = _interopRequireDefault(require("@civicplus/preamble/lib/ButtonGroup/ButtonGroup"));

var _TablePagination = _interopRequireDefault(require("@civicplus/preamble/lib/TablePagination/TablePagination"));

var _SearchInput = _interopRequireDefault(require("@civicplus/preamble/lib/SearchInput/SearchInput"));

var _RadioGroup = _interopRequireDefault(require("@civicplus/preamble/lib/RadioGroup/RadioGroup"));

var _Typography = _interopRequireDefault(require("@civicplus/preamble/lib/Typography"));

var _Alert = require("../Utility/Alert");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles2 = require("./styles");

var _core = require("@material-ui/core");

var _AssetUpload = require("../AssetUpload/AssetUpload");

var _Dialog = _interopRequireDefault(require("@civicplus/preamble/lib/Dialog"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SORT_OPTIONS = {
  NEWEST: "newest",
  OLDEST: "oldest",
  ALPHABETICALLY_ASC: "ascending",
  ALPHABETICALLY_DESC: "descending"
};
var sortOptions = [{
  id: "newestFirst",
  value: SORT_OPTIONS.NEWEST,
  label: "Newest First",
  orderBy: "lastModified desc"
}, {
  id: "oldestFirst",
  value: SORT_OPTIONS.OLDEST,
  label: "Oldest First",
  orderBy: "lastModified asc"
}, {
  id: "alphabeticallyAscending",
  value: SORT_OPTIONS.ALPHABETICALLY_ASC,
  label: "Alphabetically - Ascending",
  orderBy: "fileName asc"
}, {
  id: "alphabeticallyDescending",
  value: SORT_OPTIONS.ALPHABETICALLY_DESC,
  label: "Alphabetically - Descending",
  orderBy: "fileName desc"
}];

var searchForContent = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(api, setAssets, params) {
    var assets;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api.getAssets(params.app, params.search, params.top, params.skip, params.orderBy, params.filter);

          case 2:
            assets = _context.sent;
            setAssets(assets);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function searchForContent(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var debouncedSearchForContent = (0, _core.debounce)(searchForContent, 400);

var AssetSelector = function AssetSelector(props) {
  var _props$paginationOpti, _props$paginationOpti2;

  var modalOptions = {
    select: 0,
    upload: 1
  };

  var _useState = (0, _react.useState)(modalOptions.select),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      modalType = _useState2[0],
      setModalType = _useState2[1];

  var _useState3 = (0, _react.useState)(new _sdk.AssetsDto({
    items: [],
    _links: {},
    total: 0,
    statuses: []
  })),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      assets = _useState4[0],
      setAssets = _useState4[1];

  var selected = (0, _react.useRef)({});

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      count = _useState6[0],
      setCount = _useState6[1]; // TODO: Dig into this, why are we forcing re-render here?
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      _ = _useState8[0],
      setToggle = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      page = _useState10[0],
      setPage = _useState10[1];

  var _useState11 = (0, _react.useState)((_props$paginationOpti = (_props$paginationOpti2 = props.paginationOptions) === null || _props$paginationOpti2 === void 0 ? void 0 : _props$paginationOpti2.itemsPerPage) !== null && _props$paginationOpti !== void 0 ? _props$paginationOpti : 10),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      perPage = _useState12[0],
      setPerPage = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      search = _useState14[0],
      setSearch = _useState14[1];

  var _useState15 = (0, _react.useState)(SORT_OPTIONS.NEWEST),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      sortOption = _useState16[0],
      setSortOption = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      showFilter = _useState18[0],
      setShowFilter = _useState18[1];

  var api = new _sdk.AssetsApi(props.config);
  (0, _react.useEffect)(function () {
    var _props$value, _props$value$length, _props$value2;

    selected.current = {};
    (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.forEach(function (e) {
      if (e.id) selected.current[e.id] = e;
    });
    setCount((_props$value$length = (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.length) !== null && _props$value$length !== void 0 ? _props$value$length : 0);
  }, [props.value]);
  (0, _react.useEffect)(function () {
    function getAssets() {
      return _getAssets.apply(this, arguments);
    }

    function _getAssets() {
      _getAssets = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _Alert.alertOnError)("Failed to load assets.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                  var _sortOptions$find;

                  var filter, searchFn;
                  return _regenerator["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          filter = props.imagesOnly ? "isImage eq true" : ""; // We are going to debounce the search so we do not hit the api several times
                          // while the user is typing. But, we don't want to debounce the first load, because
                          // then our api would seem slow to the user. So we will not debounce when search is empty
                          // but debounce any other time.

                          searchFn = search === "" ? searchForContent : debouncedSearchForContent;

                          if (search === "") {
                            debouncedSearchForContent.clear();
                          }

                          _context2.next = 5;
                          return searchFn(api, setAssets, {
                            app: props.config.appName,
                            filter: filter,
                            top: perPage,
                            skip: page * perPage,
                            orderby: (_sortOptions$find = sortOptions.find(function (o) {
                              return o.value === sortOption;
                            })) === null || _sortOptions$find === void 0 ? void 0 : _sortOptions$find.orderBy,
                            search: (search === null || search === void 0 ? void 0 : search.length) > 0 ? "\"".concat(search, "\"") : undefined
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getAssets.apply(this, arguments);
    }

    if (modalType === modalOptions.select) {
      getAssets();
    } // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [page, perPage, sortOption, search, modalType]);

  var onLink = function onLink() {
    var selectedAssets = Object.values(selected.current);
    props.onAssetsLinked(selectedAssets);
    setPage(0);
    setSearch("");
  };

  function onChangeItemsPerPage(_x4) {
    return _onChangeItemsPerPage.apply(this, arguments);
  }

  function _onChangeItemsPerPage() {
    _onChangeItemsPerPage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(event) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setPerPage(event.target.value);
              setPage(0);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _onChangeItemsPerPage.apply(this, arguments);
  }

  function onChangePage(_x5, _x6) {
    return _onChangePage.apply(this, arguments);
  }

  function _onChangePage() {
    _onChangePage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_, page) {
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setPage(page);

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _onChangePage.apply(this, arguments);
  }

  var _onSearch = function onSearch(value) {
    setSearch(value);
    setPage(0);
  };

  var onChangeSortOption = function onChangeSortOption(event) {
    setSortOption(event.target.value);
  };

  var renderSortAndFilterSection = function renderSortAndFilterSection() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.selectAssetModalSortSection
    }, /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
      id: "sortOptions",
      className: "prmbl-assetSelector-SortOptions",
      name: "sortOptions",
      options: sortOptions,
      value: sortOption,
      onChange: function onChange(e) {
        return onChangeSortOption(e);
      }
    }));
  };

  var renderAssetsToSelectHeader = function renderAssetsToSelectHeader() {
    var classes = props.classes;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("prmbl-assetSelector-header", classes.selectAssetsModalHeader)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.selectAssetsModalSearch
    }, props.showFilter && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
      id: "search-assets",
      useHotkey: true,
      className: classes.selectAssetsModalFilterInput,
      onSearch: function onSearch(value) {
        return _onSearch(value);
      },
      onClear: function onClear() {
        return setSearch("");
      },
      onChange: function onChange(event) {
        return setSearch(event.target.value);
      },
      value: search
    }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: "show-filter-section",
      type: "icon",
      className: (0, _classnames["default"])("prmbl-assetSelector-filterButton", classes.selectAssetsModalFilterIcon),
      onClick: function onClick() {
        return setShowFilter(function (x) {
          return !x;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_FilterList["default"], null)))), showFilter && renderSortAndFilterSection());
  };

  var renderAssetsToSelectFooter = function renderAssetsToSelectFooter() {
    var _paginationOptions$it;

    var id = props.id,
        paginationOptions = props.paginationOptions;
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      id: "".concat(id, "-footer"),
      container: true,
      justify: "flex-end"
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true
    }, /*#__PURE__*/_react["default"].createElement(_TablePagination["default"], {
      id: "pagination-demo",
      count: assets && assets.total ? assets.total : 0,
      labelRowsPerPage: "Items per page:",
      page: page,
      rowsPerPage: perPage,
      rowsPerPageOptions: (_paginationOptions$it = paginationOptions === null || paginationOptions === void 0 ? void 0 : paginationOptions.itemsPerPageOptions) !== null && _paginationOptions$it !== void 0 ? _paginationOptions$it : [8, 16, 32, 64],
      onChangePage: onChangePage,
      onChangeRowsPerPage: onChangeItemsPerPage,
      component: "div"
    })));
  };

  var renderAssets = function renderAssets() {
    if (assets.items.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: "prmbl-assetSelector-noResults"
      }, " No Result ");
    }

    return assets.items.map(function (a, index) {
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4,
        md: 3,
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_ButtonBase["default"], {
        className: (0, _classnames["default"])("prmbl-assetSelector-assetCard", classes.buttonCorrections, a.id && selected.current[a.id] ? props.classes.selectedCard : null),
        key: "".concat(index, "-button")
      }, /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
        timeout: 1,
        "in": Boolean(a.id && selected.current[a.id] != null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("prmbl-assetSelector-assetCard-selectedIcon", classes.selectedItemCheckbox)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.selectedItemCheckboxBackground
      }, /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        className: classes.selectedItemCheckboxIcon
      })))), /*#__PURE__*/_react["default"].createElement(_AssetCard["default"], {
        id: id,
        asset: a,
        config: props.config,
        onAssetClick: function onAssetClick(asset) {
          var current = Object.keys(selected.current).find(function (f) {
            return f === asset.id;
          });

          if (current !== undefined && asset.id) {
            delete selected.current[asset.id];
          } else {
            if (!props.multiple) {
              // Force re-render by changing count when selecting a new card.
              setToggle(function (x) {
                return !x;
              });

              if (a.id) {
                selected.current = (0, _defineProperty2["default"])({}, a.id, asset);
              }
            } else {
              if (asset.id) selected.current[asset.id] = asset;
            }
          }

          setCount(Object.keys(selected.current).length);
        }
      })));
    });
  };

  var renderAssetUpload = function renderAssetUpload() {
    return /*#__PURE__*/_react["default"].createElement(_AssetUpload.AssetUpload, {
      isInDialog: true,
      config: _objectSpread({}, props.config),
      onAssetSaved: function onAssetSaved(item) {
        setModalType(modalOptions.select);
        setPage(0);
        props.onAssetSaved && props.onAssetSaved(item);
      },
      onAssetsUploaded: props.onAssetsUploaded
    });
  };

  var classes = props.classes,
      id = props.id,
      onShowAddAssets = props.onShowAddAssets;

  var renderContent = function renderContent() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: id,
      className: "prmbl-assetSelector"
    }, renderAssetsToSelectHeader(), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      className: "prmbl-assetSelector-assetsContainer",
      container: true,
      spacing: 2,
      justify: "flex-start"
    }, renderAssets()), renderAssetsToSelectFooter(), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
      layout: "right"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "prmbl-assetSelector-cancelButton",
      onClick: function onClick() {
        props.onCancel && props.onCancel();
      }
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "prmbl-assetSelector-addFilesButton",
      onClick: function onClick() {
        setModalType(modalOptions.upload);
        onShowAddAssets && onShowAddAssets();
      }
    }, "Add Files"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "prmbl-assetSelector-linkSelectedButton",
      onClick: onLink,
      color: "primary"
    }, "Link selected", " ", props.multiple ? props.imagesOnly ? "images" : "files" : props.imagesOnly ? "image" : "file", " (", count, ")")), !props.ShowAsDialog && modalType !== modalOptions.select && /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
      title: "Upload an Asset",
      open: true,
      onClose: function onClose() {
        return setModalType(modalOptions.select);
      }
    }, renderAssetUpload()));
  };

  if (props.ShowAsDialog) {
    return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
      className: "prmbl-assetSelector-dialog",
      id: "dialog",
      open: props.openDialog || false,
      onClose: function onClose() {
        if (modalType === modalOptions.upload) {
          setModalType(modalOptions.select);
        } else {
          props.onCloseDialog && props.onCloseDialog();
        }
      },
      maxWidth: "md",
      fullWidth: true,
      title: modalType === modalOptions.select ? "Select an Asset" : "Upload an Asset"
    }, modalType !== modalOptions.select ? renderAssetUpload() : renderContent());
  }

  return renderContent();
};

exports.AssetSelector = AssetSelector;
AssetSelector.defaultProps = {
  multiple: true,
  paginationOptions: {
    itemsPerPage: 8,
    itemsPerPageOptions: [8, 16, 32, 64]
  },
  openDialog: true
};

var _default = (0, _styles.withStyles)(_styles2.styles)(AssetSelector);

exports["default"] = _default;